import axios from "axios"
import { REACT_APP_API } from '../../config'

export const deleteFile = async (id) => {
    const response = await axios.delete(REACT_APP_API + `/files/${id}`)
    return response.data
}
